import { SlideUpModal } from "src/components/SlideUpModal";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";
import { useWebClientApi } from "src/api";

type DeleteExpenseModalProps = {
  isOpen: boolean;
  expense_id: string;
  closeHandler: () => void;
  deleteHandler: () => void;
};

export default ({
  isOpen,
  expense_id,
  closeHandler,
  deleteHandler,
}: DeleteExpenseModalProps) => {
  const api = useWebClientApi();
  const [submitDelete, loading] = useDlaFormSubmit(
    async () => {
      await api.deleteExpense(expense_id);
    },
    {
      onSuccess: () => deleteHandler(),
    },
  );

  if (!isOpen) return null;

  return (
    <SlideUpModal
      title="Remove this expense"
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={true}
      actionButtonText="Remove"
      actionButtonClickHandler={() => void submitDelete({})}
      isLoading={loading}
    >
      This action cannot be undone.
    </SlideUpModal>
  );
};
